export const PASSWORD_RULE_TEXT =
  "Password must be at least 10 characters, include uppercase, lowercase, and one special character, and contain no spaces.";

export function validatePassword(password) {
  const value = typeof password === "string" ? password : "";

  if (!value.trim()) {
    return { isValid: false, message: "Password is required" };
  }
  if (/\s/.test(value)) {
    return { isValid: false, message: "Password must not contain spaces" };
  }
  if (value.length < 10) {
    return { isValid: false, message: "Password must be at least 10 characters long" };
  }
  if (!/[A-Z]/.test(value)) {
    return { isValid: false, message: "Password must include an uppercase letter" };
  }
  if (!/[a-z]/.test(value)) {
    return { isValid: false, message: "Password must include a lowercase letter" };
  }
  if (!/[!@#$%^&*]/.test(value)) {
    return { isValid: false, message: "Password must include a special character" };
  }

  return { isValid: true, message: "" };
}

export function validateConfirmPassword(password, confirmPassword) {
  const value = typeof confirmPassword === "string" ? confirmPassword : "";
  if (!value.trim()) {
    return { isValid: false, message: "Confirm Password is required" };
  }
  if (password !== value) {
    return { isValid: false, message: "Confirm Password and Password do not match" };
  }
  return { isValid: true, message: "" };
}
